import React, {Component} from 'react';
import { connect } from '~/redux/connect';
import {
    getDataActionPermissions, getModelName, getPresentColumnsData,
    getResultPerPage,
    getResultSortOptions,
    getResultsValue, getTableSettingsIdentifier, getTooltipsActive, getView, getColumnWidths
} from "~/stateGetter";
import {presentColumns} from "~/statePresenter";
import {pushCurrentModelPath, pushSubview} from "~/actions/navigation_actions";
import {settingsActionCreator} from "~/actions/settingsActions";
import toOrderedArray from "~/lib/toOrderedArray";
import {compareKeys} from "mythil/object";

import identify from "~/identify";
import { modelActionsCreator } from '../../actions/model_actions';


export default function modelResultFactory({ ResultComponent }) {
    class _ModelResultComponent extends Component  {
        pushEntry = (entry, fragment) => {
            let {parentModelId, view, subviewName, pushCurrentModelPath, pushSubview} = this.props;
    
            if(view !== identify.VIEW_SUBVIEW) {
                return pushCurrentModelPath(`/${this.props.modelName}/${fragment}`, undefined, { persistQuery: true })
            }
    
            return pushSubview(parentModelId, subviewName, `/${fragment}`, { persistQuery: true });
        };
    
        viewEntry = (entry) => {
            return this.pushEntry(entry, `${entry.id.raw}/view`)
        };
    
        editEntry = (entry) => {
            let { update } = this.props;
    
            if(!update) { return this.viewEntry(entry); }
    
            return this.pushEntry(entry, `${entry.id.raw}/edit`);
        };
        
        render() {
            return <ResultComponent
                viewEntry={this.viewEntry}
                editEntry={this.props.update ? this.editEntry : null}
                {...this.props}
            />
        }
    }
    
    const _areStatePropsEqual = (prev, curr) => {
        return compareKeys(prev, curr);
    };
    
    const areStatePropsEqual = (prev, curr) => {
        let isEqual  = _areStatePropsEqual(prev, curr);
    
        if(!isEqual) {
            // console.log('ModelResultComponent areStatePropsEqual PERF', diffKeys(prev, curr));
        }
    
        return isEqual;
    };
    
    
    const ModelResultComponent = connect((state, {modelId}) => {
        return {
            tableSettingsIdentifier: getTableSettingsIdentifier(state, modelId),
            modelName: getModelName(state, modelId),
            sortOptions: getResultSortOptions(state, modelId),
            perPage: getResultPerPage(state, modelId),
            columnWidths: getColumnWidths(state, modelId),
            resultValue: getResultsValue(state, modelId),
            tooltipsActive: getTooltipsActive(state),
    
            ...getDataActionPermissions(state, modelId),
            view: getView(state, modelId),
            ...getPresentColumnsData(state, modelId)
        }
    }, (dispatch, {modelId}) => {
        let settingActions = settingsActionCreator(modelId),
            modelActions = modelActionsCreator(modelId);
    
        return {
            changeSort: (sort) => dispatch(settingActions.changeSort(sort)),
            onColumnResize: (columnWidths) => dispatch(settingActions.changeColumnWidths(columnWidths)),
            onRowSelect: (value) => dispatch(modelActions.updateSelectedRows(value)),
            onColumnReorder: (columnOrder) => dispatch(settingActions.changeColumnOrder(columnOrder)),
            pushCurrentModelPath: (...args) => dispatch(pushCurrentModelPath(...args)),
            pushSubview: (...args) => dispatch(pushSubview(...args)),
    
        }
    }, ({resultValue, ...props}, dispatchProps, {filterResultsValue, ...ownProps}) => {
        resultValue = filterResultsValue ? filterResultsValue(resultValue) : resultValue;
        resultValue = {
            ...resultValue,
            results: toOrderedArray(resultValue.results)
        };
    
        return {
            ...ownProps,
            ...dispatchProps,
            ...props,
            resultValue,
            visibleColumns: presentColumns(props).filter(c => !c.hidden)
        }
    }, {})(_ModelResultComponent);

    return ModelResultComponent
}
